module.exports = __webpack_public_path__ + "media/Main-Page-FoodSafety.63561789.mp4";